/**
 * Юрист: общие помощники путей (внешний аудит).
 */

import type { AuditScope } from '@entities/legal/types';

/**
 * REST-префикс эндпоинтов внешнего аудита по scope.
 *
 * Договор и претензия исторически имеют собственные ресурсы
 * (`/contracts/{id}`, `/claims/{id}`) — у них аудит-пакет/парсинг/сессии
 * висят прямо на ресурсе. Все четыре типа сгенерированных DOCX
 * (protocol_disagreement / response_claim / outgoing_claim / lawsuit)
 * аудируются через общий `/composed/{id}` — отдельного ресурса на тип
 * документа нет, scope лишь уточняет вид. Суффиксы (/audit-package,
 * /audit/parse, /audit/sessions) добавляет вызывающий эндпоинт.
 *
 * Важно: возвращает БАЗУ без суффикса; для contract/claim сохраняет ровно
 * прежние пути (`/contracts/{id}`, `/claims/{id}`), поэтому существующие
 * эндпоинты не меняют поведение.
 */
export const auditBase = (scope: AuditScope, id: string): string =>
  scope === 'contract'
    ? `/agents/statut/contracts/${id}`
    : scope === 'claim'
      ? `/agents/statut/claims/${id}`
      : `/agents/statut/composed/${id}`;
